import { render } from "./DeactivateWorkshop.vue?vue&type=template&id=9cde9c7c&scoped=true"
import script from "./DeactivateWorkshop.vue?vue&type=script&lang=js"
export * from "./DeactivateWorkshop.vue?vue&type=script&lang=js"

import "./DeactivateWorkshop.vue?vue&type=style&index=0&id=9cde9c7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cde9c7c"]])

export default __exports__